// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"ca1360f7","553":"47329af2"}[chunkId] + ".chunk.css";
};